module.exports = __webpack_public_path__ + "static/media/armadillo-header-logo-dark.1f4e285e.svg";